import React from 'react';
import { useHistory } from 'react-router-dom';
import { HubeeDemande } from '@mairistem/administres-utils';
import { baseUrlApp } from '@/routes';
import { RattachementIndividuHubeeModal } from '../RattachementIndividuHubeeModal';

const DemandeHubee = () => {
  const history = useHistory();
  const { pathname } = history.location;
  const identifiant = pathname.split('/hubee/')[1];

  const urlRetour = `${baseUrlApp}hubee`;

  return (
    <HubeeDemande
      identifiant={identifiant}
      apiRoute="/api/administres/recensement-citoyen/hubee/teledossiers"
      urlRetour={urlRetour}
      urlTraitement={`${baseUrlApp}recenses/assistant`}
      renderRattachementModal={({ open, onClose, demandeur }) => (
        <RattachementIndividuHubeeModal
          open={open}
          onClose={onClose}
          demandeur={demandeur}
        />
      )}
    />
  );
};

export default DemandeHubee;
